import { render, staticRenderFns } from "./BudgetChartBar.vue?vue&type=template&id=a0802254&"
import script from "./BudgetChartBar.vue?vue&type=script&lang=js&"
export * from "./BudgetChartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports